class LookbookMarquee {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('.lookbook-marquee__track');
    this.speed = Number(section.dataset.speed || 40);

    this.pos = 0;
    this.velocity = 0;
    this.raf = null;

    this.trackWidth = this.track.scrollWidth / 2;

    this.bind();
    this.start();
  }

  bind() {
    // Mouse / trackpad horizontal scroll (adds momentum, does NOT pause)
    this.section.addEventListener(
      'wheel',
      (e) => {
        e.preventDefault();
        this.velocity += e.deltaY * 0.4;
      },
      { passive: false }
    );
  }

  start() {
    let last = performance.now();

    const tick = (now) => {
      const delta = now - last;
      last = now;

      // Base auto scroll
      const pxPerMs = this.trackWidth / (this.speed * 2000);
      this.pos += pxPerMs * delta;

      // Apply user momentum
      this.pos += this.velocity;
      this.velocity *= 0.92; // smooth decay

      this.normalize();
      this.apply();

      this.raf = requestAnimationFrame(tick);
    };

    this.raf = requestAnimationFrame(tick);
  }

  normalize() {
    if (this.pos >= this.trackWidth) {
      this.pos -= this.trackWidth;
    }
    if (this.pos < 0) {
      this.pos += this.trackWidth;
    }
  }

  apply() {
    this.track.style.transform = `translateX(${-this.pos}px)`;
  }
}

// Mount
const mountMarquees = (root = document) => {
  root.querySelectorAll('[data-lookbook-marquee]').forEach((section) => {
    if (section.__marquee) return;
    section.__marquee = new LookbookMarquee(section);
  });
};

document.addEventListener('DOMContentLoaded', () => mountMarquees());
document.addEventListener('shopify:section:load', (e) =>
  mountMarquees(e.target)
);
